import { Link } from "react-router-dom";

export const ArticleSequentialNavigation = ({ previous, next }) => {
  if (!previous && !next) return null;
  return <nav className="lvmh-sequential-navigation shell" aria-label="Publication navigation" data-testid="article-sequential-navigation">
    {previous ? <Link to={previous.path} data-testid="article-previous-publication-link"><span>Previous Company Research</span><strong>← {previous.shortTitle ?? previous.title}</strong></Link> : <span />}
    {next && <Link to={next.path} data-testid="article-next-publication-link"><span>Next Company Research</span><strong>{next.shortTitle ?? next.title} →</strong></Link>}
  </nav>;
};